import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  contacts: {
    marginTop: '50px',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  section1: {
    // marginTop: '50px',
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
  contactsTitle: {
    width: '25%',
    color: '#0A0A13',
fontFamily: 'Inter',
fontSize: '36px',
fontStyle: 'normal',
fontWeight: 400,
lineHeight: '120%',
letterSpacing: '0.72px',
textAlign: 'left',
marginLeft: '45px',
[theme.breakpoints.down('sm')]: {
  width: '75%',
},
  },
  contactsInfo: {
    width: '65%',
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      marginLeft: '20px',
      width: '95%',
      justifyContent: 'flex-start',
    },
  },
  contactsInfoContent: {
    width: '18%',
    textAlign: 'left',
    color: '#232332',
    fontFamily: 'Inter',
    fontSize: '19px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '150%',
    letterSpacing: '0.19px',
    [theme.breakpoints.down('sm')]: {
      width: '15%',
      fontSize: '14px',
    },
  },
  contactsInfoSubtext: {
    width: '70%',
    textAlign: 'left',
    color: '#0A0A13',
    fontFamily: 'Inter',
    fontSize: '19px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
    letterSpacing:'0.19px',
    marginLeft: '5px',
    [theme.breakpoints.down('sm')]: {
      width: '75%',
      fontSize: '14px',
      textAlign: 'left',
      flexWrap: 'wrap',
      marginLeft: '32px',
    },
  },
  contactsMap: {
    width: '95%',
  },
}));


  export default function Contacts() {

    const classes = useStyles();
    return (
      <section className={classes.contacts}>
        <div className={classes.section1}>
  <div className={classes.contactsTitle}>
      <p>Контакти</p>
  </div>
  <div className={classes.contactsInfo}>
     <p className={classes.contactsInfoContent}> Адреса:</p><p className={classes.contactsInfoSubtext}>Україна, м. Київ, вул. Еспланадна, 8/10, 01601</p>
     <p className={classes.contactsInfoContent}> Телефон:</p><p className={classes.contactsInfoSubtext}>289-53-68, 289-66-89</p> 
     <p className={classes.contactsInfoContent}> Факс:</p><p className={classes.contactsInfoSubtext}>(044) 289-00-98</p>
      <p className={classes.contactsInfoContent}>Електронна пошта:</p><p className={classes.contactsInfoSubtext}>zvernennya@mlsp.gov.ua</p>
      </div>
        </div>
      <div className={classes.contactsMap}>
      <iframe
                title="contacts"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2541.1241209946543!2d30.51908801605533!3d50.43878867947369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cefe447bad29%3A0x8ccba36745fa33d8!2z0YPQuy4g0K3RgdC_0LvQsNC90LDQtNC90LDRjywgOC8xMCwg0JrQuNC10LIsIDAyMDAw!5e0!3m2!1sru!2sua!4v1540279832455"
                // width="100%"
                height="748px"
                frameBorder="0"
                style={{ border: 0,  borderRadius: '30px' }}
                allowFullScreen
              />
      </div>
      </section>
    );
}
